export function showMorePartners() {
    const showMoreBtn = $('.partners .show-more .button');
    const partnersList = $('.partners-list');
    const partners = partnersList.find('.item');
    const partnersLength = partners.length;

    if (partnersLength <= 6) {
        showMoreBtn.parent().hide();
    }

    showMoreBtn.on('click', function (e) {
        e.preventDefault();
        partnersList.find('.hidden').show();
        showMoreBtn.hide();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/showMorePartners.js